import { motion } from "framer-motion";

export const ChapterHeading = ({ number, title, subtitle }) => {
  return (
    <div className="relative mb-10 sm:mb-14">
      <div className="flex items-end gap-4 sm:gap-6">
        <motion.span
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-15%" }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="font-inter text-xs uppercase tracking-[0.32em] text-[#c9a961]/80"
        >
          Capítulo {number}
        </motion.span>
        <motion.span
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, margin: "-15%" }}
          transition={{ duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
          className="mb-[9px] h-px flex-1 origin-left bg-[#c9a961]/30"
        />
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-15%" }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="hidden sm:block font-inter text-[10px] uppercase tracking-[0.28em] text-[#f4e9d5]/40"
        >
          {subtitle}
        </motion.span>
      </div>

      <div className="mt-4 overflow-hidden">
        <motion.h2
          initial={{ y: "105%" }}
          whileInView={{ y: 0 }}
          viewport={{ once: true, margin: "-15%" }}
          transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
          className="font-rye text-4xl leading-[1.05] text-[#f4e9d5] sm:text-6xl md:text-7xl"
        >
          {title}
        </motion.h2>
      </div>
    </div>
  );
};
